import React, { CSSProperties } from "react";
import { Tab, Tabs } from "@material-ui/core";
import { makeStyles, Theme, withStyles } from "@material-ui/core/styles";
import { observer } from "mobx-react";
import { useStores } from "../../../../../hooks";
import { localize } from "../../../../../common/libs";
import {Trans, useTranslation} from "react-i18next";


interface StyledTabsProps {
    value: number;
    onChange: (event: React.ChangeEvent<{}>, newValue: number) => void;
}

const StyledTabs = withStyles({
    root: {
        maxWidth: '100%',
    },
    indicator: {
        display: 'flex',
        justifyContent: 'center',
        color: "#fff",
        backgroundColor: "transparent",
        '& > span': {
            minHeight: 46,
            display: "inline-block",
            width: '100%',
            borderRadius: "40px",
            zIndex: 1,
            backgroundColor: "#1B2430",
            color: "#ffffff !important",
            position: "absolute",
            top: -45
        },
    },

})((props: StyledTabsProps) => <Tabs {...props}
                                     variant="scrollable"
    /*scrollButtons="off"*/
                                     TabIndicatorProps={{ children: <span/> }}/>);

interface StyledTabProps {
    label: string;
}

const StyledTab = withStyles((theme: Theme) => ({
        root: {
            maxWidth: "1000px",
            zIndex: 20,
            cursor: "pointer",
            textTransform: 'none',
            fontWeight: 900,
            fontSize: theme.typography.pxToRem(15),
            marginRight: theme.spacing(1),
            color: "#1B2430",
            '&:focus': {
                opacity: 1,
            },
        },
        selected: {
            color: "#fff"
        }
    })
)((props: StyledTabProps) => <Tab disableRipple {...props} />);


const useStyles = makeStyles((theme: Theme) => ({
    root: {
        flexGrow: 1,
        flexShrink: 1,
    },
    padding: {
        padding: theme.spacing(3),
    },
    tabContainer: {
        /*backgroundColor: 'rgba(0,0,5,0.03)',*/
        padding: 4,
        borderRadius: 40,
        flexWrap: 'wrap'
    }

}));

const CategoriesTabs = () => {
    const classes = useStyles();
    const { menuStore } = useStores();
    const { currentMenu, selectedCategory } = menuStore;
    const {t} = useTranslation(["general", "menu"]);
    if (!currentMenu) return null;


    return (
        <div>
            <div className={classes.tabContainer}>
                <StyledTabs value={selectedCategory}
                            onChange={(e: any, value: number) => {
                                menuStore.setSelectedCategory(value);
                            }}>
                    {currentMenu.menuCategories.map((item) => {
                        const isInStopListLabel = item.data.isInStopList ? t("menu:menuEditor.inStopListBracket") : "";
                        return <StyledTab key={item.id} label={`${localize(item.data.name)} ${isInStopListLabel}`}/>
                    })}
                </StyledTabs>
            </div>

        </div>
    );
};

export default observer(CategoriesTabs)
